
import { Link } from "react-router-dom";
import Logo from "../../../../assets/images/Logo.svg";
import LogoIcon from "../../../../assets/images/FixFinderIcon.png";

interface DrawerHeaderProps {
  isOpen: boolean;
}

export default function DrawerHeader({ isOpen }: DrawerHeaderProps) {
  return (
    <div className="flex justify-center items-center pb-4 w-full">
      <Link to={"/"}>
        {isOpen ? (
          <img src={Logo} alt="Logo" className={"w-[136px] h-[32px]"} />
        ) : (
          <img src={LogoIcon} alt="Logo" className={"w-[40px] h-[40px]"} />
        )}
      </Link>
    </div>
  );
}
